// TODO beim start von Drag'n'Drop durch zwei neue config-funktion von PART. ausrechnen lassen, welcher min- oder max-Index erlaubt ist. Kamera liefert für min NaN und rechnet für max, alle anderen liefern für max NaN und für min rechnen sie wo die kamera steckt. Parameter jeweils die aktuelle Stele vor dem Start von d'n'd

// Idee neuer Workflow:
// addTemporary erzeugt Schatten-elemente an allen erlaubten Stellen (mit Hilfe einer cfg-Funktion).
//    zugleich gibt eine dynamic-Eigenschaft, die etwa der Twinspot nutzt um die temporäre Stele bei jeder Mausbewegung
// neu zu erstellen bei commit wird der Index des zugrunde-liegenden Elements ermittelt und gemeinsam mit y an den
// store übergeben commit prüft ob es ein schatten-element ist. wenn ja, wird das dortige schatten-element offiziell
// erklärt (temporary=false) und alle anderen temoorären entfern <strike>anschließend wird noch cfg.postprocess
// aufgerufen (mit Parameter stele, element, y), damit der Twinspot im Aufnahmemodul positioniert wird</strike>

// oder commit fügt einfach nochmal hinzu mit der dann gültigen y-Position

/**
 * User: herbert
 * Date: 20.10.15
 * Time: 19:22
 */

//import $ from 'jquery';
import Reflux from 'reflux';
import lzString from 'lz-string/libs/lz-string.js';

import steleActions from  '../actions/stele-actions.js';


import * as config from '../../../config.js';
import finishConfig from '../../../config-finish.js';

import StelePart from '../StelePart.js';
import SteleCharging from '../SteleCharging.js';

import T from '../../../nls/translate.js';
import {takeProperty} from '../../../helpers';


// SHOULD move initial height and constants used by setHeight to config

export default Reflux.createStore({
	init: function() {
		this.listenToMany(steleActions);
		this.state = {
			/**Array*/ current: [],
			/**Array*/ temp: null,
			/**Array*/ scopeStelen: [],
			height: 7250, // at least 7000 to have enough space for even the highest building of elements and the base
										// height of 3000
			partsHeight: 0,
			lastAddedIdxs: null,
			finish: finishConfig[0].color,
			rotation: 0,
			kasten: true,
			extraDoors: 0,
			charging: new SteleCharging(),
			tempCharging: null,
			fr: (T.region === 'fr')
		};
		const scopeParts = config.getScopeParts([false, false, false, false]);
		for (let i = 0; i < scopeParts.length; i++) {
			this.state.scopeStelen.push([]);
			for (let j = 0; j < scopeParts[i].length; j++) {
				this.state.scopeStelen[i].push(new StelePart(scopeParts[i][j]));
			}
		}
	},
	onClear: function() {
		this.lastScope = null;
		this.state.current.length = 0;
		/**Array*/ this.state.temp = null;
		this.state.lastAddedIdxs = null;
		this.state.finish = finishConfig[0].color;
		this.state.height = 7250;
		this.state.commitTime = Date.now;
		this.state.charging = new SteleCharging();
		this.state.tempCharging = null;
		this.state.fr = (T.region === 'fr');
		this.state.kasten = true;
		this.calcPartsHeight();
		this.output();
	},
	onResetToLastScopes: function() {
		this.state.temp = null;
		this.state.tempCharging = null;
		this.onResetToScopes(this.lastScope);
	},
	onResetToScopes: function(scope) {
		this.state.lastAddedIdxs = null;
		this.lastScope = scope;
		this.state.temp = null;
		this.state.charging = new SteleCharging();
		this.state.tempCharging = null;
		this.state.current.length = 0;
		const scopeParts = config.getScopeParts(scope);
		for (let i = 0; i < scope.length; i++) {
			if (scope[i]) {
				for (let j = 0; j < scopeParts[i].length; j++) {
					const cfg = scopeParts[i][j];
					if(cfg.enabled(this.state.current, this.state.partsHeight, this.state.charging)) {
						cfg.mountNew(this.state.current, new StelePart(cfg), null, null, j, null, null, false, this.state.charging);
					}
				}
			}
		}
		this.state.commitTime = Date.now();
		this.calcPartsHeight();
		this.setHeight(this.state.height);
		this.output();
	},
	onHoverScope: function(scope) {
		if(scope >= 0) {
			this.state.temp = this.state.scopeStelen[scope];
		} else {
			this.state.temp = null;
		}
		this.output();
	},
	/**
	 * add element temporary to show effect of user action
	 * @param{StelePartCfg} cfg element to add temporarilly
	 * @param{Number} centerY position of cursor where to add
	 * @param{Array} parentPositions list of parent positions
	 * @param{Number} parentIdx index of parentElement at centerY if applicable
	 * @param{Array} childPositions list of child positions of element parentIdx if applicable, else null
	 * @param{Number} childIdx index of childElement at centerY if applicable
	 */
	addTemporary: function(cfg, centerY, parentPositions, parentIdx, childPositions, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = this.state.current.slice(0);
		this.state.tempCharging = Object.assign({}, this.state.charging);
		cfg.mountNew(this.state.temp, new StelePart(cfg), centerY, parentPositions, parentIdx, childPositions, childIdx, true, this.state.tempCharging);
		this.calcPartsHeight();
		this.state.commitTime = Date.now();
		this.output();
	},
	/**
	 * commit temporary action, keep the result
	 * @param{StelePartCfg} cfg element to add
	 * @param{Number} centerY position of cursor where to add
	 * @param{Array} parentPositions list of parent positions
	 * @param{Number} parentIdx index of parentElement at centerY if applicable
	 * @param{Array} childPositions list of child positions of element parentIdx if applicable, else null
	 * @param{Number} childIdx index of childElement at centerY if applicable
	 */
	commitTemporary: function(cfg, centerY, parentPositions, parentIdx, childPositions, childIdx) {
		//console.log('commitTemporary', this.state.temp, cfg, (cfg.name === config.PART_MODUL_KAMERA_NAME || cfg.name === config.PART_MODUL_WLAN_NAME));
		if(this.state.temp) {
			//this.state.current = this.state.temp;
			this.state.temp = null;
			this.state.tempCharging = null;
			const idxs = cfg.mountNew(this.state.current, new StelePart(cfg), centerY, parentPositions, parentIdx, childPositions, childIdx, false, this.state.charging);
			this.state.lastAddedIdxs = idxs;
			if (cfg.name === config.PART_MODUL_KAMERA_NAME || cfg.name === config.PART_MODUL_WLAN_NAME || cfg.name === config.PART_MODUL_RGBW_NAME) {
				this.state.extraDoors = 1; // later: min(extraDoors+1,2);
			}
			this.state.commitTime = Date.now();
			this.calcPartsHeight();
			this.setHeight(this.state.height);
			this.output();
		}
	},
	/** rollback Temporary changes */
	rollbackTemporary: function() {
		if(!this.state.temp) return;

		this.state.temp=null;
		this.state.tempCharging=null;
		this.calcPartsHeight();
		this.state.commitTime = Date.now();
		this.output();
	},
	/** permamently remove part of current stele
	 *  @param{Number} parentIdx	index of parent element to remove
	 *  @param{Number} childIdx	if null remove whole parentIdx else only remove child childIdx from parent parentIdx
	 */
	remove: function(parentIdx, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		this.state.tempCharging = null;
		if(this.state.current[parentIdx]) {
			if(childIdx === null) {
				this.state.current.splice(parentIdx, 1);
			} else if(this.state.current[parentIdx].children && this.state.current[parentIdx].children[childIdx]) {
				this.state.current[parentIdx].children.splice(childIdx, 1);
			}
		}
		this.state.commitTime = Date.now();
		this.calcPartsHeight();
		this.output();
	},
	/** permamently remove charging from current stele
	 */
	removeCharging: function() {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		this.state.tempCharging = null;
		this.state.charging.count = 0;
		this.state.commitTime = Date.now();
		// kein this.calcPartsHeight(); weil höhenneutral
		this.output();
	},
	/**
	 * @param{Number} parentIdx index of parent element to change
	 * @param{StelePartCfg} model config entry to change size to, i.e. take name, mountNew, enabled, container from it
	 *     and merge with fitting entries from partenIdx' children
	 */
	changeSize: function(parentIdx, model) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		if(this.state.current[parentIdx]) {
			const old=this.state.current[parentIdx];
			const newPart = new StelePart(model);

			takeProperty('backCover', newPart, old);
			takeProperty('type', newPart, old);
			takeProperty('sky', newPart, old);
			takeProperty('gold', newPart, old);
			takeProperty('k2xxx', newPart, old);
			takeProperty('k3000', newPart, old);

			newPart.rotation = old.rotation;
			if(!old.container || newPart.container >= old.container) {
				newPart.children = old.children;
			} else {
				for (let i = 0; i < old.children.length; i++) {
					const child=old.children[i]; // no need to copy as parent old is detached from stele
					if(child.cfg.enabled([newPart])) {
						newPart.children[i] = old.children[i];
						child.position = null;
					}
				}
			}
			this.state.current[parentIdx] = newPart;
			this.calcPartsHeight();
			this.state.commitTime = Date.now();
		}
		this.output();
	},
	toggleBack: function(parentIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		if(this.state.current[parentIdx] && this.state.current[parentIdx].hasOwnProperty('backCover')) {
			this.state.current[parentIdx].backCover = !this.state.current[parentIdx].backCover;
			// kein Timestamp, da sich der cfgBar dadurch nicht ändert
		}
		this.output();
	},
	setFinish: function(finish) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		this.state.finish = finish;
		// kein Timestamp, da sich der cfgBar dadurch nicht ändert
		this.output();
	},
	setRotation: function(parentIdx, newRotation) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		if(this.state.current[parentIdx] && this.state.current[parentIdx].hasOwnProperty('rotation')) {
			this.state.current[parentIdx].rotation = newRotation;
			// kein Timestamp, da sich der cfgBar dadurch nicht ändert
		}
		this.output();
	},
	setGlobalRotation: function(newRotation) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		this.state.rotation = newRotation;
		// kein Timestamp, da sich der cfgBar dadurch nicht ändert
		this.output();
	},
	setType: function(type, parentIdx, childIdx, spotA) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;
		/**StelePart*/ const part = (childIdx !== null && childIdx >= 0) ?
				this.state.current[parentIdx].children[childIdx] :
				this.state.current[parentIdx];

		//const opt = part.name === config.PART_ELEMENT_TWINSPOT_NAME ?
		//		(spotA ? part.a : part.b) :
		//		part;
		//if(!!opt) {
		//	opt.type = type;
		//	this.state.commitTime = Date.now(); // timestamp für configbar
		//}
		if (part.name === config.PART_ELEMENT_TWINSPOT_NAME) {
			part.a.type = type;
			part.b.type = type;
		} else if (part.name === config.PART_MODUL_WEGE_NAME || part.name === config.PART_MODUL_WEGE2_NAME) {
			part.type = type;
			if (type === config.W_ASYM_STREET || type === config.W_ASYM_PEDESTRIAN) {
				part.sky = true;
			}
		} else {
			part.type = type;
			// Kein Down für Fassade mit F_25, Kundenwunsch 2016.11
			if (part.type === config.F_25 &&
				(part.vert === config.F_V_DOWN || part.vert === config.F_V_NEAR_DOWN)) {
				part.vert = config.F_V_PAR;
			}
		}
		this.state.commitTime = Date.now(); // timestamp für configbar
		this.calcPartsHeight();
		this.output();
	},
	setXY: function(x, y, parentIdx, childIdx, spotA) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		if(!(childIdx !== null && childIdx >= 0))	return;

		const part = this.state.current[parentIdx].children[childIdx];
		const opt = spotA ? part.a : part.b;
		if(opt) {
			if (x<-1) x=-1;
			else if (x>1) x=1;
			if (y<-1) y=-1;
			else if (y>1) y=1;
			opt.x = x;
			opt.y = y;
			// kein Timestamp, da sich der cfgBar dadurch nicht ändert
		}
		this.output();
	},
	setDirection: function(direction, parentIdx, childIdx, horiz) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		if(!(childIdx !== null && childIdx >= 0))	return;

		const part = this.state.current[parentIdx].children[childIdx];
		if(horiz) {
			part.horiz = direction;
			// down nur symmetrisch
			if( part.horiz !== config.F_H_SYM &&
				(part.vert === config.F_V_DOWN ||  part.vert === config.F_V_NEAR_DOWN))
				part.vert = config.F_V_PAR;
		} else {
			part.vert = direction;
			if(direction === config.F_V_DOWN || config.F_V_NEAR_DOWN) {
				part.type = config.F_45; // down gibt es nur in Breit 2016.11
				part.horiz = config.F_H_SYM;
			}
		}

		this.state.commitTime = Date.now(); // timestamp für configbar
		this.output();
	},
	// TODO add min and MAX_HEIGHT to config .. it depends on region and region may depend on stored data if config gets loaded!
	setHeight: function(h) {
		const maxHeight = 8000;
		const minHeight = this.state.fr || T.region === 'fr' ? 2500 : 3000;
		h=10*Math.round(h/10.0);
		if(h>maxHeight) {
			h = maxHeight;
		} else {
			// Es gibt eine Differenz zwischen dem Maßstab und den tatsächlichen Zeichnungen
			// und diese Abweichung ist für alle Module unterschiedlich.
			// Dh. Der Aufbau hat in Pixel die falsche Höhe, was man merkt, wodurch
			// bei der geringsten Größe der Aufbau nicht bei der 3m-Linie beginnt wo er aber ist.
			//// Alte Technick: damit die Grafik schön aussieht wurde einfach die Pixelhöhe genommen,
			//// Das führte zu Konfigurationen die kleinere Mastbasiselemente hatten als erlaubt.

			// neue Technik: wir rechnen mit der echten Größe in mm.
			// und nun verändern wir die Skala im Bereich 3m-8m entspechend des aktuellen Maßstabs des tatsächlichen Aufbaus
			// die Notwendige Berechnung und die veränderlichen Marken sind jetzt in der berechneten SVG von stele_theThing, siehe SteleSVG.js
			if(h<minHeight+10*Math.round(this.state.partsHeight/10))
				h=minHeight+10*Math.round(this.state.partsHeight/10);
		}
		this.state.height = h;
		// kein timestamp für configbar
		this.output();
	},
	/**
	 * set power of Gobo
	 * @param{String} power
	 * @param{Number} parentIdx
	 * @param{Number} childIdx
	 */
	setPower: function(power, parentIdx, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		const parent=this.state.current[parentIdx];
		if(parent.container && parent.children[childIdx]) {
			parent.children[childIdx].power = power;
			this.output();
		}
		// suppress output() if nothing changed
	},
	/** set light color of TwinSpot, Fassade or (deprecated:)Wege
	 * @param{Boolean} k3000 3000K if k3000 evaluates to true, else 4000K
	 * @param{Number} parentIdx index of the target Wege module or of the target's parent
	 * @param{Number} [childIdx] child-index of the target if Fassade or TwinSpot
	 */
	setK3000: function(k3000, parentIdx, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		const parent=this.state.current[parentIdx];
		if(parent && (parent.name === config.PART_MODUL_WEGE2_NAME || parent.name === config.PART_MODUL_WEGE_NAME)) {
			parent.k3000 = k3000;
			parent.k2xxx = false;
			parent.gold = false;
		} else if(parent.container && parent.children[childIdx]) {
			parent.children[childIdx].k3000 = k3000;
			if(parent.children[childIdx].k2xxx) { // forward compatibility for future
				parent.children[childIdx].k2xxx = false;
			}
		} else {
			return; // suppress output() if nothing changed
		}
		// kein Timestamp, da sich der cfgBar dadurch nicht ändert
		this.output();
	},
	/**
	 * new color setter for pieces supporting 2kK-colors
	 * @param{Boolean} k2xxx if true k3000 switches beetween 2200K and 2700K instead of 3000K and 4000K
	 * @param{Boolean} k3000 if k2xxx is false, true is 3000K and false is 4000K, if k2xxx is true a true here means 2200K and a false 2700K
	 * @param{Number} parentIdx
	 * @param{Number} [childIdx]
	 */
	setLightColor(k2xxx, k3000, parentIdx, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		const parent = this.state.current[parentIdx];
		if (parent && (parent.name === config.PART_MODUL_WEGE2_NAME || parent.name === config.PART_MODUL_WEGE_NAME)) {
			parent.k3000 = k3000;
			parent.k2xxx = k2xxx;
			if(k2xxx && k3000 && !parent.sky) {
				parent.sky = true;
			}
			if(!k2xxx) {
				parent.gold = false;
			}
		} else if (parent.container && parent.children[childIdx]) {
			// We'll use this in the paramsBar for the vert module. As there is no k2xxx we only set it if necessary
			// and we ignore gold, as it isn't available for any child type component
			parent.children[childIdx].k3000 = k3000;
			if (k2xxx || parent.children[childIdx].hasOwnProperty('k2xxx')) {
				parent.children[childIdx].k2xxx = k2xxx;
			}
		} else {
			return; // suppress output() if nothing changed
		}
		this.state.commitTime = Date.now(); // timestamp für configbar weil Ambience die beien neuen Asym. nicht unterstützt und sky eventuell angeschaltet wird
		console.log('setLightColor', {k3000, k2xxx, parent, parentIdx, childIdx});
		this.output();
	},
	/**
	 * set tritec sky reflector instead of a ambience one
	 * @param{Boolean} sky
	 * @param{Number} parentIdx
	 * @param{Number} [childIdx]
	 */
	setSky(sky, parentIdx, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		const parent=this.state.current[parentIdx];
		if(parent && (parent.name === config.PART_MODUL_WEGE2_NAME || parent.name === config.PART_MODUL_WEGE_NAME)) {
						parent.sky = sky;
			if (!sky && (parent.type === config.W_ASYM_PEDESTRIAN || parent.type === config.W_ASYM_STREET)) {
				parent.type = config.W_ASYM;
			}
			if (!sky && parent.k2xxx && parent.k3000) {
				// keine Korrektur für /GOLD nötig, da der Wert von k2xxx erhalten bleibt
				parent.k3000 = false; // 2200K sind verboten, die andere 2K-Farbtemperatur gibt es bei Sky und Ambient
			}
		} else if(parent.container && parent.children[childIdx]) {
			return; // by now this is not defined for anything else as WEGE/WEGE2, suppress output() as nothing changed
		} else {
			return; // suppress output() if nothing changed
		}
		this.state.commitTime = Date.now(); // timestamp für configbar weil Ambience die beien neuen Asym. nicht unterstützt
		this.output();
	},
	/**
	 * set tritec reflector gold instead of a silver one
	 * @param{Boolean} gold
	 * @param{Number} parentIdx
	 * @param{Number} [childIdx]
	 */
	setGold(gold, parentIdx, childIdx) {
		this.state.lastAddedIdxs = null;
		this.state.temp = null;

		const parent=this.state.current[parentIdx];
		if(parent && (parent.name === config.PART_MODUL_WEGE2_NAME || parent.name === config.PART_MODUL_WEGE_NAME)) {
			parent.gold = gold;
			if (gold && !parent.k2xxx) {
				parent.k2xxx = true; // gold → k2xxx
				parent.k3000 = false; // 2200K gibt es nur für Sky, aber auch bei Sky ist 2700K näher am alten Wert von 3000K oder 4000K
			}
		} else if(parent.container && parent.children[childIdx]) {
			return; // by now this is not defined for anything else as WEGE/WEGE2, suppress output() as nothing changed
		} else {
			return; // suppress output() if nothing changed
		}
		this.state.commitTime = Date.now(); // timestamp für configbar weil Ambience die beien neuen Asym. nicht unterstützt
		this.output();
	},
	/** set if stele base should feature a 'Kabelkasten'
	 * @param{Boolean} hasKasten true if stele base features a 'Kabelkasten', else false
	 */
	setKasten: function(hasKasten) {
		this.state.kasten = hasKasten;
		this.output();
	},
	/** set if stele base should feature a second or third additional door. Feb 2018: only one additional door is available
	 * @param{Number} number of additional doors, ie. the value 1 brings in the 2nd door
	 */
	setExtraDoors: function(extraDoors) {
		this.state.extraDoors = extraDoors;
		this.output();
	},
	/** set count of charging stations, may remove them at all
	 * @param{Number} count count of charging stations, 0, 1 or 2
	 */
	setChargingCount: function(count) {
		this.state.charging.count = count;
		this.setChargingPositioning(this.state.charging.positioning); // creates timestamp and issues output trigger
		//this.state.commitTime = Date.now(); // timestamp für configbar falls wechsel von/zu 0
		//this.output();
	},
	/** set type of charging stations,
	 * @param{String} type type of charging stations, any of config.C_TYPE_*
	 */
	setChargingType: function(type) {
		this.state.charging.type = type;
		this.output();
	},
	/** set power option of charging stations,
	 * @param{String} power power option of charging stations, any of config.C_POWER_*
	 */
	setChargingPower: function(power) {
		this.state.charging.power = power;
		this.output();
	},
	/** set count of charging stations, may remove them at all
	 * @param{Number} position number of position to set
	 *					if count == 1 allowed values: 0, 1, 2
	 *				    if count == 2 allowed values: 0, 1
	 *				    if count == 3 allowed value: 0
	 */
	setChargingPositioning: function(position) {
		const maxPosition = (this.state.charging.count === 1 || this.state.charging.count === 2) ? 2 : 0;
		if(position < 0)
			position = 0;
		else if(position > maxPosition)
			position = maxPosition;
		this.state.charging.positioning = position;
		this.state.commitTime = Date.now(); // timestamp für configbar falls wechsel von/zu 0
		this.output();
	},
	output: function() {
		//console.log("steleStore output: "+ (this.state.current !== null)+ " " + (this.state.temp !== null),
		// (this.state.temp !== null ? this.state.temp : this.state.current));
		this.trigger(this.getInitialState());
	},
	calcPartsHeight: function() {
		//this.state.height=0;
		const stele= (this.state.temp ? this.state.temp : this.state.current);
		if(stele.length < 1) {
			this.state.partsHeight = config.PART_DECKEL.H;
		} else {
			switch(stele[0].name) {
				case config.PART_MODUL_WEGE_NAME:
				case config.PART_MODUL_WEGE2_NAME:
					this.state.partsHeight = stele[0].cfg.H;
					break;
				default:
					this.state.partsHeight = config.PART_DECKEL.H + stele[0].cfg.H;
			}
		}
		for(let i=1; i<stele.length; i++) {
			console.log(stele[i].name, stele[i].cfg.H, stele[i].cfg);
			this.state.partsHeight += stele[i].cfg.H;
		}
		console.log('partsHeight', this.state.partsHeight);
	},
	/** store stele data to key. the .cfg link of parts will break but repaired at load
	 * @return{String} base64 encoded string of lz-compressed JSON data */
	getKey: function() { // this does'nt store selected scopes from scope-stores. so you won't get full ui state
		return lzString.compressToBase64(JSON.stringify({
			current: this.state.current,
			height: this.state.height,
			kasten: this.state.kasten,
			extraDoors: this.state.extraDoors,
			finish: this.state.finish,
			rotation: this.state.rotation,
			charging: this.state.charging,
			fr:	this.state.fr || (T.region === 'fr')
		}));
	},
	/** load stele data from key0. the .cfg link of parts will be broken after load and all functions lost
	 * @param{String} key base64 encoded string of lz-compressed JSON created by <code>getKey</code>
	 * @param{Function} onSuccess called when decoding finished successfull
	 * @param{Function} onError   called when decoding could not be completed and data got cleared
	 */
	loadFromKey: function(key, onSuccess, onError) {
		try {
			//console.log('loadFromKey', { decompressed: lzString.decompressFromBase64(key) });
			const loaded = JSON.parse(lzString.decompressFromBase64(key));
			console.log(loaded);
			// clear
			this.lastScope = null;
			this.state.temp = null;
			this.state.lastAddedIdxs = null;

			this.state.commitTime = Date.now;

			// take stele data. the loop in the for doesn't copy the position data, so this doesn't work an we simply trust
			// the delivered data TODO copy position data too and validate it against current rules this.state.current.length
			// = 0; if(loaded.current && loaded.current.length > 0) { for(let j=0;j<config.loaded.current.length;j++) { const
			// cfg = config.loaded.current[j]; if(cfg.enabled(this.state.current)) cfg.mountNew(this.state.current, new
			// StelePart(cfg), null, null, j, null, null, false); } }
			this.state.current = loaded.current;

			// repair .cfg as function getImg isn't stored but needed. also brings updates of hard coded data to the loaded data
			this.state.current.forEach( (/**StelePart*/part) => {
				part.cfg = config.ALL_PARTS[part.name];
				if(part.children) {
					part.children.forEach( (/**StelePart*/child) => {
						child.cfg = config.ALL_PARTS[child.name];
					});
				}
			});

			this.calcPartsHeight();
			this.setHeight(loaded.height);

			// take other data
			this.state.finish = loaded.finish;
			this.state.rotation = loaded.rotation;
			this.state.kasten = loaded.kasten;
			this.state.extraDoors = loaded.extraDoors;
			if(typeof this.state.extraDoors === 'undefined' || isNaN(this.state.extraDoors))
				this.state.extraDoors = 0;
			this.state.charging = loaded.charging ? loaded.charging : new SteleCharging();
			if(typeof this.state.charging.positioning === 'undefined' || isNaN(this.state.charging.positioning))
				this.state.charging.positioning = 0;
			this.state.fr = loaded.fr;

			// TODO some kind of data validity checks

			this.output();

			if(onSuccess)
				onSuccess();
		} catch(e) {
			console.log('load from key '+key+' failed.', e);
			this.onClear();
			if(onError)
				onError(e);
		}
	},
	getInitialState: function() {
		return {
			active: this.state.temp !== null ? this.state.temp : this.state.current,
			commited: this.state.current,
			commitTime: this.state.commitTime, // enables simple shouldComponentUpdate in config-bar.jsx
			lastAddedIdxs: this.state.lastAddedIdxs,
			finish: this.state.finish,
			rotation: this.state.rotation,
			height: this.state.height,
			kasten: this.state.kasten && !(T.region === 'fr' || this.state.fr), // this rule enforcement should be encoded in config.js
			extraDoors: this.state.extraDoors,
			neededExtraDoors: config.countNecessaryDoors(this.state.current),
			partsHeight: this.state.partsHeight,
			charging: this.state.tempCharging !== null ? this.state.tempCharging : this.state.charging,
			fr: this.state.fr
		};
	},
	getHeight: function() {
		return this.state.height;
	},
	getPartsHeight: function() {
		return this.state.partsHeight;
	},
	isStoredFR: function() {
		return this.state.fr;
	}
});
